import { createApi } from '@reduxjs/toolkit/query/react';
import { createIbkBaseQuery } from '../api/createIbkBaseQuery';
import { config } from '../config';
export const customAccountantIbkBaseQuery = createIbkBaseQuery(config.apiAccountantIbkUrl);
export const accountantIbkApi = createApi({
    reducerPath: 'accountantIbkApi',
    baseQuery: customAccountantIbkBaseQuery,
    tagTypes: ['EmissorContract'],
    endpoints: () => ({}),
});
